/* ==========================================
   TA Cart Drawer v1.0
   Torre Arka
========================================== */

(() => {
  if (window.TACartDrawerLoaded) return;
  window.TACartDrawerLoaded = true;

  const drawer = document.querySelector('[data-ta-cart-drawer]');

  if (!drawer) return;

  const itemsContainer = drawer.querySelector('[data-ta-cart-items]');
  const emptyState = drawer.querySelector('[data-ta-cart-empty]');
  const footer = drawer.querySelector('[data-ta-cart-footer]');
  const subtotal = drawer.querySelector('[data-ta-cart-subtotal]');
  const loading = drawer.querySelector('[data-ta-cart-loading]');

  function route(path) {
    const root = window.Shopify?.routes?.root || '/';
    return `${root}${path}`.replace(/\/{2,}/g, '/');
  }

  function money(cents) {
    if (
      window.Shopify &&
      typeof window.Shopify.formatMoney === 'function'
    ) {
      return window.Shopify.formatMoney(cents);
    }

    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN'
    }).format(cents / 100);
  }

  function escapeHtml(value = '') {
    const element = document.createElement('div');
    element.textContent = value;
    return element.innerHTML;
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ta-drawer-open');

    loadCart();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ta-drawer-open');
  }

  function setLoading(state) {
    loading.hidden = !state;
  }

  async function getCart() {
    const response = await fetch(route('cart.js'), {
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('No se pudo cargar el carrito.');
    }

    return response.json();
  }

  async function loadCart() {
    setLoading(true);

    try {
      const cart = await getCart();
      renderCart(cart);
      updateBubble(cart.item_count);
    } catch (error) {
      console.error('TA Cart Drawer:', error);
    } finally {
      setLoading(false);
    }
  }

  function renderCart(cart) {
    const isEmpty = cart.item_count === 0;

    emptyState.hidden = !isEmpty;
    footer.hidden = isEmpty;
    itemsContainer.hidden = isEmpty;

    if (isEmpty) {
      itemsContainer.innerHTML = '';
      return;
    }

    subtotal.textContent = money(cart.total_price);

    itemsContainer.innerHTML = cart.items
      .map((item, index) => {
        const image = item.image
          ? `
            <img
              class="ta-drawer__item-image"
              src="${item.image}"
              alt="${escapeHtml(item.product_title)}"
              width="96"
              height="112"
              loading="lazy"
            >
          `
          : '';

        return `
          <article
            class="ta-drawer__item"
            data-ta-cart-line="${index + 1}"
          >
            <div class="ta-drawer__item-media">
              ${image}
            </div>

            <div class="ta-drawer__item-info">
              <a
                href="${item.url}"
                class="ta-drawer__item-title"
              >
                ${escapeHtml(item.product_title)}
              </a>

              <span class="ta-drawer__item-price">
                ${money(item.final_price)}
              </span>

              <button
                type="button"
                class="ta-drawer__remove"
                data-ta-cart-remove
                aria-label="Eliminar ${escapeHtml(item.product_title)}"
              >
                ×
              </button>

              <div class="ta-drawer__item-bottom">
                <div class="ta-drawer__quantity">
                  <button
                    type="button"
                    class="ta-drawer__qty-button"
                    data-ta-cart-decrease
                    aria-label="Reducir cantidad"
                  >
                    −
                  </button>

                  <span class="ta-drawer__qty-value">
                    ${item.quantity}
                  </span>

                  <button
                    type="button"
                    class="ta-drawer__qty-button"
                    data-ta-cart-increase
                    aria-label="Aumentar cantidad"
                  >
                    +
                  </button>
                </div>

                <strong class="ta-drawer__line-total">
                  ${money(item.final_line_price)}
                </strong>
              </div>
            </div>
          </article>
        `;
      })
      .join('');
  }

  async function changeLine(line, quantity, itemElement) {
    setLoading(true);
    itemElement?.classList.add('is-updating');

    try {
      const response = await fetch(route('cart/change.js'), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          line,
          quantity
        })
      });

      const cart = await response.json();

      if (!response.ok) {
        throw new Error(
          cart.description ||
          cart.message ||
          'No se pudo actualizar el carrito.'
        );
      }

      renderCart(cart);
      updateBubble(cart.item_count);

      document.dispatchEvent(
        new CustomEvent('ta:cart-updated', {
          detail: { cart }
        })
      );
    } catch (error) {
      console.error('TA Cart Drawer:', error);
      await loadCart();
    } finally {
      setLoading(false);
      itemElement?.classList.remove('is-updating');
    }
  }

  function updateBubble(count) {
    const bubbleLink = document.querySelector('#cart-icon-bubble');

    if (!bubbleLink) return;

    let bubble = bubbleLink.querySelector('.cart-count-bubble');

    if (count <= 0) {
      bubble?.remove();
      return;
    }

    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML = `
        <span aria-hidden="true"></span>
        <span class="visually-hidden"></span>
      `;
      bubbleLink.appendChild(bubble);
    }

    const visible = bubble.querySelector('[aria-hidden="true"]');
    const accessible = bubble.querySelector('.visually-hidden');

    if (visible) visible.textContent = count;

    if (accessible) {
      accessible.textContent =
        `${count} artículos en el carrito`;
    }
  }

  drawer.addEventListener('click', (event) => {
    const close = event.target.closest('[data-ta-drawer-close]');

    if (close) {
      closeDrawer();
      return;
    }

    const itemElement = event.target.closest('[data-ta-cart-line]');

    if (!itemElement) return;

    const line = Number(itemElement.dataset.taCartLine);
    const quantityElement = itemElement.querySelector(
      '.ta-drawer__qty-value'
    );

    const currentQuantity = Number(
      quantityElement?.textContent || 1
    );

    if (event.target.closest('[data-ta-cart-increase]')) {
      changeLine(line, currentQuantity + 1, itemElement);
    }

    if (event.target.closest('[data-ta-cart-decrease]')) {
      changeLine(
        line,
        Math.max(0, currentQuantity - 1),
        itemElement
      );
    }

    if (event.target.closest('[data-ta-cart-remove]')) {
      changeLine(line, 0, itemElement);
    }
  });

  document.addEventListener('click', (event) => {
    const cartIcon = event.target.closest('#cart-icon-bubble');
    const miniCartLink = event.target.closest(
      '.ta-mini-cart__cart-link'
    );

    if (!cartIcon && !miniCartLink) return;

    event.preventDefault();
    openDrawer();
  });

  document.addEventListener('ta:cart-added', () => {
    /*
     * No lo abrimos automáticamente para conservar
     * el mini cart que ya construimos.
     */
    loadCart();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeDrawer();
    }
  });

  window.TACartDrawer = {
    open: openDrawer,
    close: closeDrawer,
    refresh: loadCart
  };
})();